
import { useState, useEffect } from 'react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { Combobox } from '@headlessui/react'



function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const TextCombo = ({ defaultValue, handleDepartamento, setFieldValue, data, title, id, value="", setSelected, handleClick = console.log('función por defecto') }) => {
  
  const [query, setQuery] = useState('')
  const [selectedPerson, setSelectedPerson] = useState(null)

  const [codigoDepto, setCodigoDepto] = useState('')


  useEffect(() => {
    setCodigoDepto(defaultValue)
  }, [])

  useEffect(() => {
    console.log("QUERY:", value)
    handleDepartamento(setFieldValue, value)
  }, [value])
  

  const filteredPeople =
    query === ''
      ? data
      : data.filter((person) => {
          return person['Departamento'].toLowerCase().includes(query.toLowerCase())
        })

  return (
    <Combobox as="div" value={value} onChange={setSelected} onClick={()=> handleClick}>
      <Combobox.Label className="block mx-2 text-md /font-medium /leading-6 text-white">{title}</Combobox.Label>
      <div className="relative mt-2">
        <Combobox.Input
          className="w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-azulBrillanteMira sm:text-sm sm:leading-6"
          onChange={(event) => setQuery(() => event.target.value)}
          value={defaultValue}
          displayValue={ (person) => person?.Departamento || data.find((e) => e.Codigo == value)?.Departamento || value}
        />
        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
          <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
        </Combobox.Button>

        {filteredPeople.length > 0 && (
          <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {filteredPeople.map((person) => (
              <Combobox.Option
                key={person?.Codigo}
                value={person}
                className={({ active }) =>
                  classNames(
                    'relative cursor-default select-none py-2 pl-3 pr-9',
                    active ? 'bg-azulBrillanteMira  text-white' : 'text-gray-900'
                  )
                }
              >
                {({ active, selected }) => (
                  <>
                    <span className={classNames('block truncate', selected && 'font-semibold')}>{`${person['Departamento']}`}</span>

                    {selected && (
                      <span
                        className={classNames(
                          'absolute inset-y-0 right-0 flex items-center pr-4',
                          active ? 'text-white' : 'text-azulBrillanteMira'
                        )}
                      >
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  )
}

export {
    TextCombo,
}